<template>
  <div v-if="statement" class="flex gap-x-4">
    <InputField
      v-model="statement.data.value"
      type="number"
      :label="$t('logicStatement.number.value')"
      :placeholder="$t('logicStatement.number.value')"
      :error="errors?.value"
      :disabled="disabled"
      class="my-4 w-1/2"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import InputField from '@utils/inputs/Input.vue';
import type { FilterPrototype, LogicStatement, MaybeHydra } from '@/entities/Entities';

interface Props {
  modelValue?: MaybeHydra<
    LogicStatement<{
        value: number;
    }>
  >;
  prototype: FilterPrototype<{ value: string }, Record<string, never>>;
  errors?: object;
  disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);
const statement = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped></style>
